import {
  Container,
  FormControlLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { getCarrierByBusinessName } from "../../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";
import Header from "../header/Header";
import { getMoveService } from "../../redux/action/move-service";

const Packing = ({
  setTotalCostOffPacking,
  setBoxCubicFeet,
  totalCostOfPacking,
  setTotalMovePrice,
  setPriceOfItemsOnly,
  setPackingBoxesCount,
  setLabourCost,
  squareFootage,
  setIsStuffFactorPopulated,
  finalMoverRate,
}: any) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  useEffect(() => {
    console.log(finalMoverRate, "changing now");
  }, [finalMoverRate]);
  const { businessName, canonicalId } = useParams();
  const [carrier, setCarrier] = useState<any>(null);
  const [boxRates, setBoxRates] = useState<any>(null);
  const calculateLabourCost = (move: any, factor: any) => {
    let weight = 0;
    if (move.distance > 200) {
      if (move.dwelling_type !== "storage") {
        weight = move.total_cubic_feet * 7;
      } else if (move.dwelling_type === "storage") {
        weight = move.storage.storage_cubic_feet * 7;
      }
    } else if (move.distance <= 200) {
      weight = squareFootage * 6.5;
    }
    let manHours = 0;
    manHours = weight * (Number(factor) / 8);
    let costOfLabour = Math.ceil(manHours * finalMoverRate);
    setLabourCost(costOfLabour);
  };
  useEffect(() => {
    if (businessName) {
      dispatch<any>(getCarrierByBusinessName(businessName))
        .then(unwrapResult)
        .then((res: any) => {
          setBoxRates(res.boxRate);
          setCarrier(res);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  }, [businessName]);
  const [moveService, setMoveService] = useState<any>(null);

  useEffect(() => {
    if (canonicalId) {
      getMoveById();
    }
  }, [canonicalId]);
  const getMoveById = () => {
    dispatch<any>(getMoveService(canonicalId || ""))
      .then(unwrapResult)
      .then((res: any) => {
        setMoveService(res);
        setTotalPounds(Number(res.total_cubic_feet) * 7);
      })
      .catch((err: any) => {
        console.log(err);
      });
  };
  const handleNext = () => {
    // dispatch(setStep(5));
    navigate(`/${carrier.business_name}/move-price/${canonicalId}`);
  };
  const stuffFactors = [
    { factor: 0.007, description: "Minimalist" },
    { factor: 0.01, description: "In the middle" },
    { factor: 0.016, description: "Too much to handle" },
  ];
  const [costOfPackingLabor, setCalculateCostOfPackingLabor] = useState(false);
  const longDistanceBoxes = (event: any) => {
    setPriceOfItemsOnly(0.0);
    setTotalMovePrice(0.0);
    setSelectedFactor(event.target.value);
    const boxCount = totalPounds * event.target.value;
    setTotalBoxCount(Math.ceil(boxCount));
    const smallBoxCount = Math.ceil(0.24 * boxCount);
    const smallBoxesVolume = Math.ceil(smallBoxCount * 1.5);
    const smallBoxesPrice =
      Math.ceil(0.24 * boxCount) * parseInt(boxRates.small_box) * 2.5;
    const mediumBoxesCount = Math.ceil(0.25 * boxCount);
    const mediumBoxesVolume = Math.ceil(mediumBoxesCount * 3);

    const mediumBoxesPrice =
      Math.ceil(0.25 * boxCount) * parseInt(boxRates.medium_box) * 2.5;
    const largeBoxesCount = Math.ceil(0.21 * boxCount);
    const largeBoxesVolume = Math.ceil(largeBoxesCount * 4.5);

    const largeBoxesPrice =
      Math.ceil(0.21 * boxCount) * parseInt(boxRates.large_box) * 2.5;
    const dishPacksCount = Math.ceil(0.12 * boxCount);
    const dishPacksVolume = Math.ceil(dishPacksCount * 5.25);
    const dishPacksPrice =
      Math.ceil(0.12 * boxCount) * parseInt(boxRates.dish_pack) * 2.5;
    const mirrorCartonsCount = Math.ceil(0.1 * boxCount);
    const mirrorCartonsVolume = Math.ceil(mirrorCartonsCount * 3.5);

    const mirrorCartonsPrice =
      Math.ceil(0.1 * boxCount) * parseInt(boxRates.mirror_cartons) * 2.5;
    const wardrobBoxesCount = Math.ceil(0.08 * boxCount);
    const wardrobBoxesVolume = Math.ceil(wardrobBoxesCount * 13.5);
    const wardrobBoxesPrice =
      Math.ceil(0.08 * boxCount) * parseInt(boxRates.wardrobe_box) * 2.5;

    const totalVolumeOfBboxes = Math.ceil(
      smallBoxesVolume +
        mediumBoxesVolume +
        largeBoxesVolume +
        dishPacksVolume +
        mirrorCartonsVolume +
        wardrobBoxesVolume
    );
    console.log(totalVolumeOfBboxes, "-Calculated volume of boxes");
    setBoxCubicFeet(totalVolumeOfBboxes);
    const totalCostOfPacking = Math.ceil(
      smallBoxesPrice +
        mediumBoxesPrice +
        largeBoxesPrice +
        dishPacksPrice +
        mirrorCartonsPrice +
        wardrobBoxesPrice
    );
    setPackingBoxesCount({
      smallBoxes: smallBoxCount,
      mediumBoxes: mediumBoxesCount,
      largeBoxes: largeBoxesCount,
      dishPacks: dishPacksCount,
      mirrorCartons: mirrorCartonsCount,
      wardrobeBoxes: wardrobBoxesCount,
    });
    console.log(
      {
        smallBoxes: smallBoxCount,
        mediumBoxes: mediumBoxesCount,
        largeBoxes: largeBoxesCount,
        dishPacks: dishPacksCount,
        mirrorCartons: mirrorCartonsCount,
        wardrobeBoxes: wardrobBoxesCount,
      },
      "setPackingBoxesCount--------"
    );
    calculateLabourCost(moveService, event.target.value);
    setTotalCostOffPacking(totalCostOfPacking);
  };
  const localBoxes = (event: any) => {
    setPriceOfItemsOnly(0.0);
    setTotalMovePrice(0.0);
    setSelectedFactor(event.target.value);
    let weight = squareFootage * 6.5;
    const boxCount = weight * event.target.value;
    setTotalBoxCount(Math.ceil(boxCount));
    const smallBoxCount = Math.ceil(0.24 * boxCount);
    const smallBoxesVolume = Math.ceil(smallBoxCount * 1.5);
    const smallBoxesPrice =
      Math.ceil(0.24 * boxCount) * parseInt(boxRates.small_box) * 2.5;
    const mediumBoxesCount = Math.ceil(0.25 * boxCount);
    const mediumBoxesVolume = Math.ceil(mediumBoxesCount * 3);

    const mediumBoxesPrice =
      Math.ceil(0.25 * boxCount) * parseInt(boxRates.medium_box) * 2.5;
    const largeBoxesCount = Math.ceil(0.21 * boxCount);
    const largeBoxesVolume = Math.ceil(largeBoxesCount * 4.5);

    const largeBoxesPrice =
      Math.ceil(0.21 * boxCount) * parseInt(boxRates.large_box) * 2.5;
    const dishPacksCount = Math.ceil(0.12 * boxCount);
    const dishPacksVolume = Math.ceil(dishPacksCount * 5.25);
    const dishPacksPrice =
      Math.ceil(0.12 * boxCount) * parseInt(boxRates.dish_pack) * 2.5;
    const mirrorCartonsCount = Math.ceil(0.1 * boxCount);
    const mirrorCartonsVolume = Math.ceil(mirrorCartonsCount * 3.5);

    const mirrorCartonsPrice =
      Math.ceil(0.1 * boxCount) * parseInt(boxRates.mirror_cartons) * 2.5;
    const wardrobBoxesCount = Math.ceil(0.08 * boxCount);
    const wardrobBoxesVolume = Math.ceil(wardrobBoxesCount * 13.5);
    const wardrobBoxesPrice =
      Math.ceil(0.08 * boxCount) * parseInt(boxRates.wardrobe_box) * 2.5;

    // const totalVolumeOfBboxes = Math.ceil(
    //   smallBoxesVolume +
    //     mediumBoxesVolume +
    //     largeBoxesVolume +
    //     dishPacksVolume +
    //     mirrorCartonsVolume +
    //     wardrobBoxesVolume
    // );
    // console.log(totalVolumeOfBboxes, "-Calculated volume of boxes");
    // setBoxCubicFeet(totalVolumeOfBboxes);
    const totalCostOfPacking = Math.ceil(
      smallBoxesPrice +
        mediumBoxesPrice +
        largeBoxesPrice +
        dishPacksPrice +
        mirrorCartonsPrice +
        wardrobBoxesPrice
    );
    console.log(totalCostOfPacking, "COST FOR LOCAL MOVE");
    setPackingBoxesCount({
      smallBoxes: smallBoxCount,
      mediumBoxes: mediumBoxesCount,
      largeBoxes: largeBoxesCount,
      dishPacks: dishPacksCount,
      mirrorCartons: mirrorCartonsCount,
      wardrobeBoxes: wardrobBoxesCount,
    });
    console.log(
      {
        smallBoxes: smallBoxCount,
        mediumBoxes: mediumBoxesCount,
        largeBoxes: largeBoxesCount,
        dishPacks: dishPacksCount,
        mirrorCartons: mirrorCartonsCount,
        wardrobeBoxes: wardrobBoxesCount,
      },
      "setPackingBoxesCount--------"
    );
    calculateLabourCost(moveService, event.target.value);
    setCalculateCostOfPackingLabor(true);
    setTotalCostOffPacking(totalCostOfPacking);
  };

  const [selectedFactor, setSelectedFactor] = useState<any>("");
  useEffect(() => {
    if (selectedFactor !== "" && finalMoverRate !== 0.0) {
      calculateLabourCost(moveService, selectedFactor);
    }
  }, [finalMoverRate, selectedFactor]);
  const [totalPounds, setTotalPounds] = useState(0.0);
  const [totalBoxCount, setTotalBoxCount] = useState(0);
  const handleChange = (event: any) => {
    setIsStuffFactorPopulated(true);
    if (moveService.distance > 200) {
      longDistanceBoxes(event);
    } else if (moveService.distance <= 200) {
      console.log("calculating local move formulaaaaa");
      localBoxes(event);
    }
  };
  return (
    <div>
      {/* <Header /> */}
      {/* <Container
        sx={{
          width: "100%",
          maxWidth: "100%",
          height: isMobile ? "93vh" : "80vh",
          boxShadow: "0px 4px 10px rgba(0,0,0,0.1)",
          padding: isMobile ? "20px" : "20px",
          background: "#f2f0f0",
          margin: "0 auto",
          display: "flex",
          flexDirection: "column",
          //   justifyContent: "space-between",
        }}
      > */}
      <Typography variant="h6" align="center" gutterBottom>
        Select Stuff Factor
      </Typography>
      <RadioGroup
        value={selectedFactor}
        onChange={handleChange}
        sx={{
          textAlign: "center",
        }}
      >
        {stuffFactors.map((item, index) => (
          <FormControlLabel
            key={index}
            value={item.factor}
            control={<Radio />}
            label={item.description}
            sx={{ marginBottom: 2 }}
          />
        ))}
      </RadioGroup>
      {totalBoxCount !== 0 ? (
        <Typography>
          Number of boxes you will require: {totalBoxCount}
        </Typography>
      ) : null}
      {/* </Container> */}
    </div>
  );
};
export default Packing;
